<script lang="ts">
    import { createEventDispatcher } from "svelte";

    export let error = false;
    export let value = "";

    const dispatch = createEventDispatcher();
    const onChange = (event: Event) => {
        if (event.target instanceof HTMLTextAreaElement) {
            dispatch("change", { value: event.target.value, event });
        }
    };
</script>

<textarea
    class="gw-rv-textarea"
    class:gw-rv-textarea--error={error}
    {value}
    on:input={onChange}
    {...$$restProps}
/>

<style lang="postcss">
    .gw-rv-textarea {
        --input-border-color: rgba(38, 40, 66, 0.12);
        --input-border-color-focus: #007995;
        --input-border-radius: 10px;

        box-sizing: border-box;
        width: calc(100% - 2px);
        padding: 12px;
        border: 1px solid var(--input-border-color);
        border-radius: var(--input-border-radius);
        font-family: inherit;
        font-size: 0.875em;
        line-height: 1.4em;
        background: transparent;
        box-shadow: none;
        margin: 1px;
        resize: none;
        color: inherit;

        &:focus {
            outline: none;
            border: 2px solid var(--input-border-color-focus);
            margin: 0;
        }
        &--error {
            border-color: var(--gw-error-color);
            color: var(--gw-error-color);
        }

        &--error:focus-visible {
            outline: 2px solid var(--gw-error-color);
        }

        @media all and (max-width: 480px) {
            font-size: clamp(16px, 1em, 24px);
        }
    }
</style>
